import React, { memo, useCallback, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { FullScreenLoader } from 'src/components/shared/FullScreenLoader'
import { Button } from 'src/components/shared/Button'
import tw from 'twin.macro'
import { ChevronLeftMinor } from '@shopify/polaris-icons'
import { CustomerInsuranceForm } from 'src/components/customer/customer-insurance-form/CustomerInsuranceForm'
import { useSelector } from 'react-redux'
import { getCustomerCollectedDataById } from 'src/selectors/customer'
import { ROUTES } from 'src/constants/routes'

const CustomerResubmitInsurancePageComponent = () => {
  const navigate = useNavigate()
  const params = useParams()

  const collectedDataId = params?.collectedDataId || null

  useEffect(() => {
    if (!collectedDataId) {
      navigate(ROUTES.BASE_URL)
    }
  }, [collectedDataId])

  const collectedData = useSelector(getCustomerCollectedDataById(collectedDataId))

  const handleBack = useCallback(() => {
    navigate(ROUTES.BASE_URL)
  }, [navigate])

  if (!collectedData) {
    return <FullScreenLoader />
  }

  return (
    <div data-testid="customer-account-resubmit-insurance-page">
      <CustomerInsuranceForm collectedData={collectedData} onSubmit={handleBack} />
      <div css={tw`absolute left-4 top-20`}>
        <Button
          data-testid="customer-account-resubmit-back-btn"
          onClick={handleBack}
          leftIcon={<ChevronLeftMinor width={20} height={20} fill="white" />}
          size="small"
          color="black"
        >
          Back
        </Button>
      </div>
    </div>
  )
}

export const CustomerResubmitInsurancePage = memo(CustomerResubmitInsurancePageComponent)
